import React from "react";
import PropTypes from "prop-types";
// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
// import Table from "../../views/Table/Table.js";
// import TablePagination from "../../views/Table/TablePagination.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";
import axios from "axios";
import { CircularProgress, Tooltip } from "@material-ui/core";
import style from "./orders.module.css";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Button from "@material-ui/core/Button";
import ConfOrder from "./../order/confOrder/ConfOrder";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import Snackbar from "../utils/snackbar/Snackbar";
import GeneratePdf from "./generatePdf/GeneratePdf";
// import GenerateExcel from './generateExcel/GenerateExcel';
import GenerateExcel from "./../Sales/generateExcel/GenerateExcel";
import { connect } from "react-redux";
import TopBar from "../utils/Topbar/TopBar.js";
import DownloadBarcode from "./barcodePdf/DownloadBarCode.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";
import { ArrowBackRounded } from "@material-ui/icons";
import NonApprovedOrder from "./../order/nonAppprovedOrder/NonApprovedOrder";
import DownloadOrder from "./../order/downloadOrder/DownloadOrder";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EventBusyIcon from "@material-ui/icons/EventBusy";
// React Pagination
import styles from "../../assets/jss/material-dashboard-react/components/tableStyle.js";
import TableContainer from "@material-ui/core/TableContainer";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

const theme = createMuiTheme({
  palette: {
    action: {
      disabledBackground: "#00BFFF",
      disabled: "white",
    },
  },
});
const useStyles = makeStyles(styles);
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
const TablePaginationActions = (props) => {
  console.log("ss props");
  console.log(props);
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;
  console.log("TablePaginationActions");
  console.log(
    "count:" +
      count +
      ":page:" +
      page +
      ":rowsPerPage:" +
      rowsPerPage +
      ":onChangePage:"
  );
  const handleFirstPageButtonClick = (event) => {
    console.log("handleFirstPageButtonClick");
    console.log(page);
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    console.log("handleBackButtonClick");
    console.log(page);
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    console.log("handleNextButtonClick");
    console.log(page);
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    console.log("handleLastPageButtonClick");
    console.log(page);
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
const SalesOrderList = (props) => {
  const [orders, setOrders] = React.useState(false);
  const [addModal, setAddModal] = React.useState(false);
  const [editModal, setEditModal] = React.useState(false);
  const [activeOrder, setActiveOrder] = React.useState(false);
  const [nonApprovedOrder, setNonApprovedOrder] = React.useState(false);
  const [downloadOrder, setDownloadOrder] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [filteredDataTotalCount, setFilteredDataTotalCount] = React.useState(0);
  const [filteredData, setFilteredData] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [selectValue, setSelectValue] = React.useState("ALL");
  const [selectOrderStatus, setSelectOrderStatus] = React.useState([
    "New Order",
    "Confirm Order",
    "Ready For Dispatch",
    "Dispatched",
    "Delivered",
  ]);
  const [warehouse, setWarehouse] = React.useState([]);
  const [partners, setPartners] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [parts, setParts] = React.useState([]);
  const [tableRowData, setTableRowData] = React.useState([]);

  const [plants, setPlants] = React.useState([]);
  const classes = useStyles();
  const tableHeaderColor = "primary";
  const tableHead = [
    "Sl No",
    "Order Barcode",
    "Order Type",
    "Order to",
    "Create Date",
    "Order Location",
    "Order Delivery Adress",
    "Status",
    "Action",
  ];
  // console.log("order : "+tableData)
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isuserType, setUserType] = React.useState(true);
  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, orderData.length - page * rowsPerPage);
  const handleChangePage = (event, newPage) => {
    console.log("handleChangePage");
    console.log("page:" + page);
    console.log("new page:" + newPage);
    setPage(newPage);
    // if(filteredDataTotalCount > orderData.length) {
    //   console.log('inside page:'+page);
    let limit = rowsPerPage;
    let pageNumber = newPage;
    fetchOrder(pageNumber, limit);
    // }
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("ww event");
    console.log(event);
    console.log(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // if(filteredDataTotalCount > orderData.length) {
    let limit = event.target.value;
    let pageNumber = 0;
    fetchOrder(pageNumber, limit);
    // }
  };
  const validateuser = () => {
    return props.user.userType.toLowerCase() === "warehouse".toLowerCase()
      ? setUserType(false):
      props.user.userType.toLowerCase() === "sales".toLowerCase()
      ? setUserType(false)
      : props.user.userType.toLowerCase() === "admin".toLowerCase()
      ? setUserType(false)
      : setUserType(true);
  };

  React.useEffect(() => {
    setFilteredData(false);
    let limit = 10;
    let pageNumber = 0;
    setPage(pageNumber);
    setRowsPerPage(parseInt(10));
    fetchOrder(pageNumber, limit);
  }, [selectOrderStatus]);
  React.useEffect(() => {
    axios({
      method: "post",
      url: "/getAllWarehouse",
    })
      .then((res) => {
        setWarehouse(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "post",
      url: "/getAllPartner",
      data: {
        userId: props.user._id,
      },
    })
      .then((res) => {
        setPartners(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "post",
      url: "/getAllProductPart",
      data: {
        userId: props.user._id,
      },
    })
      .then((res) => {
        setParts(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "post",
      url: "/getAllProductsApi",
      data: {
        userId: props.user._id,
      },
    })
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios({
      method: "post",
      url: "/getAllManufacturingPlant",
      data: {
        userId: props.user._id,
      },
    })
      .then((res) => {
        setPlants(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    validateuser();
  }, []);

  React.useEffect(() => {
    if (orders) {
      let arr = [];
      arr = orders.filter((val) => {
        if (
          val.orderLocation.toLowerCase().includes(searchValue.toLowerCase()) ||
          val.truckNo.toLowerCase().includes(searchValue.toLowerCase())
        ) {
          return val;
        }
      });
      arr = arr.filter((val) => {
        if (val.orderType == selectValue || selectValue == "ALL") {
          return val;
        }
      });

      // arr = arr.filter(val => {
      // if(selectOrderStatus.includes(val.orderStatus) || selectOrderStatus.includes('ALL')) {
      // return val;
      // }
      // if(val.orderStatus == selectOrderStatus || selectOrderStatus == "ALL") {
      //   return val;
      // }
      // })
      setFilteredData(arr);
    }
    // },[searchValue,selectValue,selectOrderStatus])
  }, [searchValue, selectValue]);
  let isLoading = !filteredData;
  let showData = !isLoading;
  const fetchOrder = (pageNumber = null, limit = null) => {
    setFilteredData(false);
    setOrders(false);
    setTableRowData([]);
    console.log("fetchOrder");
    console.log("p:" + pageNumber + ":limit:" + limit);
    pageNumber = pageNumber != null ? pageNumber : 0;
    limit = limit != null ? limit : 10;
    axios({
      method: "post",
      url: "/getAllOrder",
      data: {
        userId: props.user._id,
        orderType: "sales",
        orderStatus: selectOrderStatus,
        pageNumber: pageNumber,
        limit: limit,
      },
    })
      .then((res) => {
        setFilteredDataTotalCount(res.data.totalCount);
        setOrders(res.data.data);
        setFilteredData(res.data.data);
        let resData = res.data.data;
        console.log("API data:");
        console.log(resData);
        let tableRows = [];
        resData.forEach((order, index) => {
          tableRows.push([
            index + 1,
            order.order_barcode,
            order.orderType,
            order.orderType == "sales"
              ? order.partner && order.partner.name
              : order.warehouse && order.warehouse.name,
            order.orderDate,
            order.orderLocation,
            order.deliveryAddress,
            order.orderStatus,
            <React.Fragment>
              {/* <DownloadBarcode order={order} />
              <GeneratePdf order={order} />
              <GenerateExcel order={order} />   */}
              <Tooltip title="Edit Order">
                <IconButton
                  onClick={() => {
                    setActiveOrder(order);
                    setEditModal(true);
                  }}
                >
                  <EditRoundedIcon />
                </IconButton>
              </Tooltip>

              <ConfirmAlert
                msg="Are you sure you want delete this order ?"
                onClickEvent={() => handleDelete(order)}
              >
                <Tooltip title="Delete Order">
                  <IconButton>
                    <DeleteRoundedIcon />
                  </IconButton>
                </Tooltip>
              </ConfirmAlert>

              <Tooltip title="Order Product/Parts">
                <IconButton
                  onClick={() => {
                    setNonApprovedOrder(order);
                  }}
                >
                  <EventBusyIcon color="default" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Downloads">
                <IconButton
                  onClick={() => {
                    setDownloadOrder(order);
                  }}
                >
                  <GetAppRoundedIcon />
                </IconButton>
              </Tooltip>
            </React.Fragment>,
          ]);
        });
        console.log("order");
        if (tableRows.length > 0) {
          console.log("set tableRowdata");
          setTableRowData(tableRows);
          showData = true;
        } else {
          console.log("unset tableRowdata");
          setTableRowData([]);
          showData = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (order) => {
    axios({
      method: "post",
      url: "/deleteOrder",
      data: {
        userId: props.user._id,
        orderId: order._id,
      },
    })
      .then((res) => {
        setAlert("Deleted Successfully");
        let limit = 10;
        let pageNumber = 0;
        setPage(pageNumber);
        setRowsPerPage(parseInt(10));
        fetchOrder(pageNumber, limit);
      })
      .catch((err) => {
        setAlert("Something went wrong");
      });
  };
  let orderTypes = ["ALL"];
  // let orderStatus = ["ALL"]
  let orderStatus = [
    "New Order",
    "Confirm Order",
    "Ready For Dispatch",
    "Dispatched",
    "Delivered",
  ];
  // orders && orders.forEach(val => {
  //   orderTypes.push(val.orderType)
  //   orderStatus.push(val.orderStatus);
  // });
  orderTypes = [...new Set(orderTypes)];
  orderStatus = [...new Set(orderStatus)];
  const orderData = [];

  // !isLoading && filteredData.forEach((order,index) => {
  //   orderData.push(
  //     [
  //       index + 1,
  //       order.order_barcode,
  //       order.orderType,
  //       order.orderType == "sales" ? order.partner && order.partner.name : order.warehouse && order.warehouse.name,
  //       order.orderDate,
  //       order.orderLocation,
  //       order.deliveryAddress,
  //       order.orderStatus,
  //       <React.Fragment>
  //         <DownloadBarcode order={order} />
  //         <GeneratePdf order={order} />
  //         <GenerateExcel order={order} />
  //         <Tooltip title="Edit Order">
  //           <IconButton onClick={() => {
  //             setActiveOrder(order)
  //             setEditModal(true)
  //           }}>
  //             <EditRoundedIcon />
  //           </IconButton>
  //         </Tooltip>

  //         <ConfirmAlert msg="Are you sure you want delete this order ?" onClickEvent={() => handleDelete(order)}>
  //           <Tooltip title="Delete Order">
  //             <IconButton>
  //               <DeleteRoundedIcon />
  //             </IconButton>
  //           </Tooltip>
  //         </ConfirmAlert>

  //         <Tooltip title="Non Approved Order">
  //         <IconButton  onClick={() => {
  //           setNonApprovedOrder(order)
  //         }}>
  //           <VisibilityIcon color="primary" />
  //         </IconButton>
  //       </Tooltip>
  //       <Tooltip title="Download Order">
  //         <IconButton  onClick={() => {
  //           setDownloadOrder(order)
  //         }}>
  //         <VisibilityIcon color="primary" />
  //         </IconButton>
  //       </Tooltip>

  //       </React.Fragment>
  //     ]
  //   )
  // });
  return (
    <GridContainer>
      {addModal && (
        <ConfOrder
          type="ADD"
          open={addModal}
          onClose={() => setAddModal(false)}
          onDone={() => {
            setAddModal(false);
            let limit = 10;
            let pageNumber = 0;
            setPage(pageNumber);
            setRowsPerPage(parseInt(10));
            fetchOrder(pageNumber, limit);
            // fetchOrder();
          }}
          setAlert={(msg) => setAlert(msg)}
          warehouse={warehouse}
          products={products}
          parts={parts}
          plants={plants}
        />
      )}

      {activeOrder && (
        <ConfOrder
          type="EDIT"
          order={activeOrder}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActiveOrder(false);
            let limit = 10;
            let pageNumber = 0;
            setPage(pageNumber);
            setRowsPerPage(parseInt(10, 10));
            fetchOrder(pageNumber, limit);
            // fetchOrder()
          }}
          setAlert={(msg) => setAlert(msg)}
          warehouse={warehouse}
          products={products}
          partners={partners}
          parts={parts}
          plants={plants}
        />
      )}

      {activeOrder && (
        <ConfOrder
          type="EDIT"
          order={activeOrder}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActiveOrder(false);
            let limit = 10;
            let pageNumber = 0;
            setPage(pageNumber);
            setRowsPerPage(parseInt(10, 10));
            fetchOrder(pageNumber, limit);
            // fetchOrder();
          }}
          setAlert={(msg) => setAlert(msg)}
          warehouse={warehouse}
          products={products}
          partners={partners}
          parts={parts}
          plants={plants}
        />
      )}

      {nonApprovedOrder && (
        <NonApprovedOrder
          open={nonApprovedOrder}
          onClose={() => setNonApprovedOrder(false)}
          orders={nonApprovedOrder}
        />
      )}
      {downloadOrder && (
        <DownloadOrder
          open={downloadOrder}
          onClose={() => setDownloadOrder(false)}
          order={downloadOrder}
        />
      )}

      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <TopBar
        searchValue={searchValue}
        onSearchChange={(value) => setSearchValue(value)}
        select={false}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Order Type"
        options={orderTypes}
        values={orderTypes}
        select2={false}
        selectValue2={selectOrderStatus}
        handleSelectChange2={(value) => setSelectOrderStatus(value)}
        lable2="Order Status"
        options2={orderStatus}
        values2={orderStatus}
        select3={true}
        selectValue3={selectOrderStatus}
        handleSelectChange3={(value) => {
          if (value[value.length - 1] === "all") {
            setSelectOrderStatus(
              selectOrderStatus.length === orderStatus.length ? [] : orderStatus
            );
            return;
          }
          setSelectOrderStatus(value);
        }}
        lable3="Order Status"
        options3={orderStatus}
        values3={orderStatus}
        multiple3={true}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary" className={style.cardHeader}>
            <h4>All Orders</h4>
            <ThemeProvider theme={theme}>
              <Tooltip title={isuserType ? "Disabled" : ""}>
                <span>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setAddModal(true)}
                    disabled={isuserType}
                    style={{ backgroundColor: "#00BFFF" }}
                  >
                    Add Order
                  </Button>
                </span>
              </Tooltip>
            </ThemeProvider>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}

            {showData && (
              <div>
                <TableContainer style={{ minHeight: 400, maxHeight: 400 }}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    className={classes.table}
                  >
                    {tableHead !== undefined ? (
                      <TableHead
                        className={classes[tableHeaderColor + "TableHeader"]}
                      >
                        <TableRow className={classes.tableHeadRow}>
                          {tableHead.map((prop, key) => {
                            return (
                              <TableCell
                                className={
                                  classes.tableCell +
                                  " " +
                                  classes.tableHeadCell
                                }
                                key={key}
                              >
                                {prop}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                    ) : null}
                    {tableRowData.length > 0 ? (
                      <>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? tableRowData.length > page * rowsPerPage
                              ? tableRowData.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                              : tableRowData
                            : tableRowData
                          ).map((prop, key) => {
                            return (
                              <TableRow
                                hover
                                key={key}
                                className={classes.tableBodyRow}
                              >
                                {prop.map((prop, key) => {
                                  return (
                                    <TableCell
                                      className={classes.tableCell}
                                      key={key}
                                    >
                                      {prop}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </>
                    ) : (
                      <div className="centerAlign">
                        <p>No Data Found</p>
                      </div>
                    )}
                  </Table>
                </TableContainer>
                <TableFooter>
                  <TableRow className={classes.tableBodyRow}>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        20,
                        50,
                        { label: "All", value: -1 },
                      ]}
                      colSpan={20}
                      count={filteredDataTotalCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </div>
            )}
            {}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});
export default connect(mapStateToProps)(SalesOrderList);
